/**
 * Elemento "Regola di validazione"
 * TODO
 */
export type IRule = Record<string, any>;

export enum RuleType {
  Required = 'required',
  LengthRange = 'lengthRange',
  TextFormat = 'textFormat',
  ValueRange = 'valueRange',
  Integer = 'integer',
  Positive = 'positive',
  DateRange = 'dateRange',
  ItemRange = 'itemRange',
  RepeatableRange = 'repeatableRange',
  UniqueField = 'uniqueField',
  MaxDimension = 'maxDimension',
  NeedSign = 'needSign',
  FileType = 'fileType',
  CustomWarnings = 'customWarnings',
}
